import { Field } from 'formik';
import i18next from 'i18next';
import { CustomSelectComponent, FsProps } from 'motion-components';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export enum yAxisValues {
  Weight = 1,
  CollectionsCount = 2,
}
export const FieldSelectYAxis = ({
  label = i18next.t('Άθροισμα κατά (y-άξονας)'),
  name = 'yAxisId',
  disable = false,
  ...rest
}: FsProps & { readonly disable?: boolean }) => {
  const { t, i18n } = useTranslation();
  //
  const options = [
    { value: yAxisValues.Weight, label: t('Βάρος Υλικού') },
    { value: yAxisValues.CollectionsCount, label: t('Πλήθος Συλλογών') },
  ];

  return (
    <Field
      className="mb-2"
      name={name}
      title={label}
      component={CustomSelectComponent}
      options={options}
      isDisabled={disable}
      as={Row}
    />
  );
};
